import React from "react";
import { Button } from "primereact/button";
import _ from "lodash";
import { Accordion, AccordionTab } from "primereact/accordion";
import Cucina from "./Cucina";

const Cucine = (props) => {
  
  const handleAggiungiCucina = () => {
    const cucineAggiornato = [...props.preventivo.cucine];
    cucineAggiornato.push(null);
    props.onChange(cucineAggiornato);
  }

  const handleRimuoviCucina = (indice) => {
    const app = [...props.preventivo.cucine];
    app.splice(indice, 1);
    props.onChange(app);
  }

  const handleAggiornacucina = (cucina, indice) => {
    props.preventivo.cucine[indice] = cucina;
    props.onChange(props.preventivo.cucine);
  }

  //console.log("props.preventivo.cucine", props.preventivo.cucine);
  const renderCucina = (indice, singolo) => {
    
    return (
      <>
        {
          <Cucina
            preventivo={props.preventivo}
            indice={indice}
            singolo = {singolo}
            handleRimuoviCucina={(keyr) => handleRimuoviCucina(keyr)}
            onChange={(cucina, keyc) => handleAggiornacucina(cucina, keyc)}
          />
        }
      </>
    );
  };

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
        <div className="text-900 font-medium text-900 text-xl mb-2"></div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
          {/* Nota: sono compresi materiali necessari per l'edificazione della
              struttura, escludendo qualsiasi decoro aggiuntivo specificatamente
              richiesto dal committente*/}
              
        </p>
        {
          props?.preventivo?.cucine?.length > 1 ? (
          <Accordion activeIndex={props.preventivo?.cucine.length - 1}>
            {props.preventivo.cucine.map((elem, indice) => (
              <AccordionTab header={"Cucina " + (indice + 1)}>
                {renderCucina(indice, false)}
              </AccordionTab>
            ))}
          </Accordion>
        ) : (
          <div className="surface-card p-4 shadow-2 border-round">
            {renderCucina(0, true) }
          </div>
        )}

        <Button
          type="button"
          label="Aggiungi altra cucina"
          className="px-5 py-3 mt-5 w-auto"
          onClick={() => handleAggiungiCucina()}
        />
      </div>
    </>
  );
};
export default Cucine;
